import Axios from "@/plugins/Axios";

export class PlanosMensaisService {
  async planoMensal(gestaoDeAulaId, mes_id, disciplinaId) {
    const response = await Axios().get(
      `planos-mensais/plano-mensal/${gestaoDeAulaId}/${mes_id}/${disciplinaId}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-mensais/criar-plano-mensal`, {
      plano,
    });
    return response.data;
  }

  async planoMensalPDF(gestaoDeAulaId, mes, disciplinaId, file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await Axios().post(
      `planos-mensais/uploadPdf/${gestaoDeAulaId}/${mes}/${disciplinaId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const resultData = response.data ?? response;
    if (resultData) {
      return resultData;
    }
    // console.warn("Upload bem-sucedido, mas sem resposta significativa do servidor.");
    return null;
  }

  async planoMensalDownload(gestaoDeAulaId, mes, disciplinaId) {
    const response = await Axios()
      .get(`planos-mensais/downloadPdf/${gestaoDeAulaId}/${mes}/${disciplinaId}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }

  async removerPlanoMensal(gestaoDeAulaId, mes, disciplinaId) {
    const response = await Axios().delete(
      `planos-mensais/remover-plano-mensal/${gestaoDeAulaId}/${mes}/${disciplinaId}`
    );
    return response.data;
  }

  async visualizarPath(path) {
    const response = await Axios().get(`planos-mensais/visualizar-path/${path}`, {
      responseType: "arraybuffer",
    });
    return response.data;
  }
}
export default new PlanosMensaisService();
